module.exports = __webpack_public_path__ + "static/img/title_01@2x.b9fd80a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/title_01@2x.png
// module id = ls2P
// module chunks = 1